export default {
    wolbachia_included_0: 'Not included',
    wolbachia_included_1: 'Included',
};
